import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import type { Table } from "@/lib/pos-types";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const zones = ["Terraza", "Interior", "Bar", "VIP"];

export function createClientId(prefix: string): string {
  const random =
    typeof crypto !== "undefined" && "randomUUID" in crypto
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  return `${prefix}-${random}`;
}

export function formatPrice(price: number | string | null | undefined): string {
  const numericPrice = Number(price);

  const safePrice = Number.isFinite(numericPrice) ? numericPrice : 0;

  return new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency: "CLP",
    minimumFractionDigits: 0,
  }).format(safePrice);
}

export function toMs(val: Date | string | number | null | undefined): number {
  if (!val) return 0;
  if (val instanceof Date)
    return Number.isNaN(val.getTime()) ? 0 : val.getTime();
  if (typeof val === "number") return Number.isFinite(val) ? val : 0;
  const d = new Date(String(val));
  return Number.isNaN(d.getTime()) ? 0 : d.getTime();
}

export function getTableStatusColor(status: Table["status"]): string {
  switch (status) {
    case "available":
      return "bg-emerald-500/20 border-emerald-500 text-emerald-400";
    case "occupied":
      return "bg-amber-500/20 border-amber-500 text-amber-400";
    case "blocked":
      return "bg-zinc-500/20 border-zinc-500 text-zinc-400";
    case "pending-payment":
      return "bg-violet-500/20 border-violet-500 text-violet-400";
    default:
      return "bg-zinc-500/20 border-zinc-500 text-zinc-400";
  }
}

export function getTableStatusLabel(status: Table["status"]): string {
  switch (status) {
    case "available":
      return "Disponible";
    case "occupied":
      return "Ocupada";
    case "blocked":
      return "Bloqueada";
    case "pending-payment":
      return "Por pagar";
    default:
      return "Desconocido";
  }
}
